import { render, staticRenderFns } from "./personnelImproved.vue?vue&type=template&id=48ec2ba8&scoped=true&"
import script from "./personnelImproved.vue?vue&type=script&lang=js&"
export * from "./personnelImproved.vue?vue&type=script&lang=js&"
import style0 from "./personnelImproved.vue?vue&type=style&index=0&id=48ec2ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec2ba8",
  null
  
)

export default component.exports